import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import RequireAuth from 'routes/RequireAuth';
import FreedomForEver from 'pages/ff/FreedomForEver';


// public pages
const HomePage = Loadable(lazy(() => import('pages/home/HomePage')));
const ActivateAccount = Loadable(lazy(() => import('sections/auth/ActivateAccount')));
const SetupTOTP = Loadable(lazy(() => import('sections/auth/SetupTOTP')));

// dashboard pages
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

const VXPurchase = Loadable(lazy(() => import('pages/verifications/VXPurchase')));
const VOEDetailVX = Loadable(lazy(() => import('pages/verifications/VOEDetailVX')));
const VXAccount = Loadable(lazy(() => import('pages/verifications/VXAccount')));

const EmployeePin = Loadable(lazy(() => import('pages/employee/EmployeePin')));
const ConfirmTOTP = Loadable(lazy(() => import('sections/auth/ConfirmTOTP')));
const ReleaseFormsPage = Loadable(lazy(() => import('pages/releaseForms/ReleaseFormsPage')));


const MainRoutes = {
  path: '/',
  children: [
    // ✅ Home at "/"
    {
      index: true,
      element: <HomePage />
    },
    { 
      path: 'ff', 
      element: <FreedomForEver /> 
    },

    // ✅ Activation at "/activate-account"
    {
      path: 'activate-account',
      element: <ActivateAccount />
    },
    {
      path: 'setup-totp',
      element: <SetupTOTP />
    },
    {
      path: 'confirm-totp',
      element: <ConfirmTOTP />
    },
    {
      path: 'employee',
      element: <EmployeePin />
    },

    // ✅ Admin app under "/app"
    {
      path: 'app',
      element: (
        <RequireAuth>
          <DashboardLayout />
        </RequireAuth>
      ),
      children: [
        {
          path: 'dashboard/default',
          element: <DashboardDefault />
        },
        // optional shortcut: /app -> /app/dashboard/default
        {
          index: true,
          element: <DashboardDefault />
        },
        { path: 'typography', element: <Typography /> },
        { path: 'color', element: <Color /> },
        { path: 'shadow', element: <Shadow /> },
        { path: 'sample-page', element: <SamplePage /> },
        { path: 'vx-purchase', element: <VXPurchase /> },
        { path: 'voe-detail-vx', element: <VOEDetailVX /> },
        {
          path: 'verifications/vx-account',
          element: <VXAccount />
        },
        {
          path: 'releaseForms/release-forms',
          element: <ReleaseFormsPage />
        }
      ]
    }
  ]
};

export default MainRoutes;
